import { useEffect, useState } from 'react';

export function useCssVar(varName: string) {
    const read = () => getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    const [value, setValue] = useState(() => {
        try {
            return read();
        } catch {
            return '';
        }
    });

    useEffect(() => {
        // Si tu changes la variable via JS, mets à jour l'état
        const observer = new MutationObserver(() => setValue(read()));
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
        return () => observer.disconnect();
    }, [varName]);

    const set = (newVal: string) => document.documentElement.style.setProperty(varName, newVal);
    return [value, set];
}
